import { ExtrudeFeatureDefinitionModel } from '../../definition/extrude/ExtrudeFeatureDefinition';
import { ExtrudeFeatureCommandParamsBuilder } from './ExtrudeFeatureCommandParamsBuilder';
import { ExtrudeFeatureEditDefinitionSanitizer } from './ExtrudeFeatureEditDefinitionSanitizer';
import type { ExtrudeFeatureEditDefinition } from './ExtrudeFeatureEditDefinition';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/edit/extrude 层；
 * 2. 负责把拉伸编辑定义转换为正式的特征定义对象；
 * 3. 该类只处理特征定义对象创建，不承担默认值和 UI 净化职责。
 *
 * 文件职责：
 * 1. 统一触发编辑定义净化；
 * 2. 统一组装命令参数并创建 `ExtrudeFeatureDefinitionModel`；
 * 3. 为桥接层和 facade 提供稳定的特征定义构建入口。
 */
export class ExtrudeFeatureDefinitionBuilder {
    /**
     * 根据编辑定义构建拉伸特征定义对象。
     *
     * @param input 构建输入。
     * @returns 拉伸特征定义对象。
     */
    public static buildFeatureDefinition(input: {
        featureKind: ExtrudeFeatureKind;
        baseParams: Omit<
            ExtrudeParams,
            'depth' | 'direction' | 'startOffset' | 'mergeResult' | 'direction1' | 'direction2' | 'thinFeature'
        >;
        definition: ExtrudeFeatureEditDefinition;
    }): ExtrudeFeatureDefinitionModel {
        const sanitizedDefinition = ExtrudeFeatureEditDefinitionSanitizer.sanitize(input.definition);

        return ExtrudeFeatureDefinitionModel.fromParams({
            featureKind: input.featureKind,
            commandParams: ExtrudeFeatureCommandParamsBuilder.buildCommandParamsFromSanitized(
                input.baseParams,
                sanitizedDefinition,
            ),
        });
    }
}
